import { render, staticRenderFns } from "./BindCardManage.vue?vue&type=template&id=910c48ea&scoped=true"
import script from "./BindCardManage.vue?vue&type=script&lang=js"
export * from "./BindCardManage.vue?vue&type=script&lang=js"
import style0 from "./BindCardManage.vue?vue&type=style&index=0&id=910c48ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910c48ea",
  null
  
)

export default component.exports